import React from 'react';
import { withRouter } from 'react-router-dom';
// import GoogleMap from '../google-map';
import OffersGrid from '../offers-grid';
import ProjectOffersGrid from '../project-offers-grid';
import ServerApi from '../../services/server-api-service';
import CookiesManager from '../../services/cookies-manager';
import AgentCard from '../agent-card';
import { Helmet } from 'react-helmet';

// import HeaderSelection from '../header-selection';
import './selection-page-style.css';

class SelectionPage extends React.Component {
  serverApi = new ServerApi();
  cookiesManager =  new CookiesManager();
  constructor(props) {
    super(props);
    this.state = {
      debug: false,
      listingExpiredList: [],
      data: {
        // title: 'Title',
        // notes: 'Notes',
        // date: new Date().toTimeString(),
      }
    }
  }

  componentDidMount(){
  }

  componentWillMount() {
    if (this.cookiesManager.get('exit_pop') === undefined || this.cookiesManager.get('exit_pop') !== '1') {
      this.cookiesManager.set('exit_pop', 1, 365);
    }
    if (this.cookiesManager.get(this.props.match.params.selectionId)) {
      let listingExpiredList = JSON.parse(this.cookiesManager.get(this.props.match.params.selectionId))
      if (listingExpiredList) {
        this.setState({
          listingExpiredList: listingExpiredList
        })
      }
    }
    if (this.props.match.params.selectionId) {
      this.serverApi.getSelection(this.props.match.params.selectionId, this.props.match.params.agentId)
        .then((data) => {
          this.setState({
            data: data
          })
          let projectMarkers = []
          if(data.offers){
              data.offers.map((offer)=>{
                offer.project.marker.offerId=offer.id;
                if(offer.project.marker) projectMarkers.push(offer.project.marker)  
              })
          }


          this.props.saveSelectionListings(data.listings.concat(projectMarkers), this.props.match.params.selectionId, this.props.match.params.agentId);
          this.props.saveCurrentSelectionListing(null);
        })
        .catch((error) => {
          console.log(`ERROR: fetch getSelection ... -> Component: Seletion-Page ERROR:${error}`);
          //this.props.history.replace({pathname:`/page-not-found`});
        })
    }
    let initialData = {
      mapSide: "left",
      selectionHeader: true,
      showSelectionToolBar: false,
      selectionMapFloating: false,
      selectionMapSettings: {
        elementHeaderId: "HeaderSelection",
        elementHeaderIdOffset: null,
        elementFooterId: "Footer",
        elementFooterIdOffset: '',
      },
      currentPage: 'SelectionPage',
      pageIsLoaded:true,
      
      displayOnMobileSelectionMap: true
    }
    this.props.saveState(initialData);
    // this.props.saveState('mapSide','left');
    // this.props.saveState('selectionHeader',true);
    // this.props.saveState('showSelectionToolBar',false);
    // this.props.saveState('selectionMapFloating',false);

    let page = document.getElementsByClassName('SelectionPage')[0];
    if (page != null) {
      if (this.props.widthRouterMark !== page.clientWidth) {
        this.props.saveState({
          widthRouterMark: page.clientWidth,
          heightRouterMark: page.clientHeight
        })
      }
    }
  }

  componentWillUnmount(){
    let initialData = {
      // mapSide: "left",
      selectionHeader: true,
      showSelectionToolBar: false,
      selectionMapFloating: false,
      currentPage: 'SelectionPage',
      pageIsLoaded:false,
      displayOnMobileSelectionMap: false
    }
    if(this.props.saveState)this.props.saveState(initialData);
  }

  componentWillUpdate(){
    if(this.props.widthRouterMark == 0 || this.props.widthRouterMark =='auto'){
      let page  = document.getElementsByClassName('SelectionPage')[0];
      if(page != null){
         if(this.props.widthRouterMark !== page.clientWidth){
          this.props.saveState({
              widthRouterMark:page.clientWidth,
              heightRouterMark:page.clientHeight
          })
         }
      }
    }
    
  }

  render() {
    let { dictionary, width, agentId, hoveredMarkerId, saveState } = this.props;
    let { title, notes, listings, date, agent,offers } = this.state.data;
    const contactWA = require('../../elements/images/contactWA.png');
    //const logoImg = require('../../elements/images/logo_positive_center.png');
    let body = null;
    if (this.state.data !== undefined && listings !== undefined) {
      body = (
        <div className="Page SelectionPage"  style={{width:'auto'}}>
         <Helmet>
          <meta name="robots" content="noindex"/>
        </Helmet>
          <div className="PageBody">
            <AgentCard
              width = {width}
              title={title}
              notes={notes}
              agent={agent}
              date={date}
              selection={true}
            />

            <div className="SelectionLine">
              <div className="SearchBlock">
                <div className="TopPart">
                  <div className="Offers">
                    <OffersGrid
                      hoveredMarkerId={hoveredMarkerId}
                      selectionId={this.props.match.params.selectionId}
                      selectionData={this.state.data}
                      title={dictionary.featured_deals}
                      data={listings}
                      width={width}
                      dictionary={dictionary}
                      verticalList={true}
                      agentId={agentId}
                      selection={true}
                      dealScore={false}
                      smartDealEnable={false}
                      listingExpiredList={this.state.listingExpiredList}
                      saveState={saveState}
                    />
                    {offers&&
                      <ProjectOffersGrid
                        width={width} 
                        selectionData={this.state.data}
                        dictionary={dictionary}
                        data={offers}
                        hoveredMarkerId={hoveredMarkerId}
                        saveState={saveState}
                        vertical={true}
                      />
                    }
                  </div>

                  <div>
                    
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      )
    }

    return (
      <>
        {body}
      </>
    )
  };

}

export default withRouter(SelectionPage);